import api from "./api";

// 删除推送消息
export async function pushInfoOriginDataRecordDelete(id: number) {
  const res = await api.post<unknown>(`push_info_origin_data_record/delete`, {
    id
  });
  return res.data;
}
